import { action, computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
// Import styles
import styles from './style.scss';

// Import Components

@inject('ViewStore')
@observer
class MediaContainer extends Component {
  @observable loaded = false;
  @observable faded  = false;

  @computed
  get opacity() {
    return this.faded
      ? 1
      : 0;
  }

  componentDidMount() {
    this._fadeInImage();
    this._fadeInContainer();
  }

  componentDidUpdate() {
    this._fadeInImage();
  }

  _fadeInImage() {
    const { mc } = this.props;

    if(mc.thumbnail) {
      const img  = new Image();
      img.onload = this._onImageLoad.bind(this);
      img.src    = mc.thumbnail;
    }
  }

  _fadeInContainer() {
    _.delay(action(() => {
      this.faded = true;
    }), 10);
  }

  _onImageLoad() {
    _.delay(() => {
      this._changeLoaded(true);
    }, 500);
  }

  @action
  _changeLoaded(bool) {
    this.loaded = bool;
  }

  navigateToMc(mc) {
    const { ViewStore } = this.props;
    const lang          = ViewStore.language;
    const directLink    = _.split(mc.directLink, '/');
    const channel       = _.head(directLink);
    const detail        = _.last(directLink);

    ViewStore.router.navigate('detail', {
      lang:    ViewStore.language,
      channel: channel,
      detail:  detail,
    }, {});
  }

  onKeyDown = (event) => {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.navigateToMc(this.props.mc);
    }
  }

  render() {
    const { mc, isMobile, inTeaser, ViewStore } = this.props;
    return (
      <div
        className={styles.mediaContainer + ( inTeaser ? (' ' + styles.inTeaser) : '' )}
        style={{ opacity: this.opacity }}
        >

        <div
          className={styles.imageContainer}
          onClick={() => this.navigateToMc(mc)}
          onKeyDown={this.onKeyDown}
          tabIndex={0}
          aria-label={mc.title}
        >
          <div className={styles.playIconWrap} >
            <svg x='0px' y='0px' viewBox='-197 320.9 200 200' >
              <circle cx='-92.5' cy='423.3' r='75.5' />
              <path
                d='M-101.9,464.4c-2.4,0-4.8-0.9-6.7-2.7c-3.9-3.7-4-9.9-0.3-13.8l21.8-22.9l-21.7-22.7c-3.7-3.9-3.6-10,0.3-13.8c3.9-3.7,10-3.6,13.8,0.3l28.2,29.4c3.6,3.8,3.6,9.7,0,13.4l-28.2,29.6C-96.7,463.4-99.3,464.4-101.9,464.4L-101.9,464.4zM-101.9,464.4' />
            </svg >
          </div >
          <img
            className={this.loaded
              ? styles.imageLoaded
              : styles.image}
            src={mc.thumbnail}
            alt={mc.title} />

        </div >
        <div className={styles.infoContainer} >

          <h4
          className={styles.mcTitle} >
            {mc.title}
          </h4 >
          <p className={styles.mcInfo} >
            {`${mc.created} | ${mc.duration} `}
          </p >
          <button
          className={styles.mcLink}
          onKeyDown={this.onKeyDown}
          onClick={() => this.navigateToMc(mc)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"></path>
            </svg>

            <div className={styles.mcLinkInner}>
              { ViewStore.get('watchVideo') }
            </div>
          </button>

        </div >
      </div >
    );
  }
}

export default MediaContainer;



// WEBPACK FOOTER //
// ./src/components/MediaContainer/index.js